module.exports = __webpack_public_path__ + "img/logo.dfe8625a.png";